import {
  CLEAR,
  ERROR,
  SUCCESS,
} from './mutation-types';

export default {
  [CLEAR](state) {
    // state.alerts.splice(index, 1);
    state.alert = {};
  },
  [ERROR](state, msg) {
    state.alert = {
      type: 'danger',
      msg,
    };
  },
  [SUCCESS](state, msg) {
    state.alert = {
      type: 'success',
      msg,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/alert/mutations.js